import { render, staticRenderFns } from "./SalesGoodsBySalesGroup.vue?vue&type=template&id=1a78376c"
import script from "./SalesGoodsBySalesGroup.vue?vue&type=script&lang=js"
export * from "./SalesGoodsBySalesGroup.vue?vue&type=script&lang=js"
import style0 from "./SalesGoodsBySalesGroup.vue?vue&type=style&index=0&id=1a78376c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports